import { Link, useLocation } from 'react-router-dom'

/**
 * An honest stand-in for a page that does not exist yet.
 *
 * Deliberately not a fake screen: a plausible-looking empty dashboard would
 * read as "this feature works and has no data", which is a lie that costs
 * someone a bug report. This says what it is.
 */
export function Placeholder({ title }: { title: string }) {
  // Echo the search terms back. The query is real and arrived here; only the
  // results are missing — saying so beats a page that looks like it ignored you.
  const query = new URLSearchParams(useLocation().search).get('q')

  return (
    <section className="card sec" style={{ padding: '40px 20px', textAlign: 'center' }}>
      <h2 className="h2" style={{ justifyContent: 'center' }}>{title}</h2>
      {query && (
        <p className="sub" style={{ marginTop: 8 }}>
          Searched for <b>“{query}”</b>
        </p>
      )}
      <p className="sub" style={{ marginTop: 8 }}>
        This page has not been built yet. The Home dashboard is the section
        ported so far.
      </p>
    </section>
  )
}

export function NotFound() {
  return (
    <section className="card sec" style={{ padding: '40px 20px', textAlign: 'center' }}>
      <h2 className="h2" style={{ justifyContent: 'center' }}>Page not found</h2>
      <p className="sub" style={{ marginTop: 8 }}>
        That address does not match anything in NexExec.
      </p>
      <Link className="btn" to="/" style={{ marginTop: 14, display: 'inline-flex' }}>
        Back to dashboard
      </Link>
    </section>
  )
}
